import React from 'react';
import { Box, Typography } from '@mui/material';

const TeamCampaignsList = () => {
    return (
        <Box sx={{ p: 3, border: '1px dashed #ccc', borderRadius: '8px', textAlign: 'center' }}>
            <Typography variant="body1" sx={{ color: '#666' }}>
                No campaigns found. Create your first campaign!
            </Typography>
        </Box>
    );
};

export default TeamCampaignsList;

